/* Depot header: mobile menu toggle and promo rotation.
   Deliberately dependency-free so the header keeps working regardless of
   which Dawn scripts a given template happens to load. */

(function () {
  'use strict';

  function initMenu(root) {
    var burger = root.querySelector('[data-depot-burger]');
    var menu = root.querySelector('[data-depot-menu]');
    if (!burger || !menu) return;

    function setOpen(open) {
      menu.setAttribute('data-open', open ? 'true' : 'false');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });

    // Escape closes the menu and returns focus to the control that opened it.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      burger.focus();
    });

    // A resize back to desktop must clear the mobile open state, otherwise
    // the panel stays stuck open behind the desktop layout.
    var desktop = window.matchMedia('(min-width: 990px)');
    var onChange = function (event) {
      if (event.matches) setOpen(false);
    };
    if (desktop.addEventListener) {
      desktop.addEventListener('change', onChange);
    } else if (desktop.addListener) {
      desktop.addListener(onChange);
    }
  }

  function initPromos(root) {
    var wrap = root.querySelector('[data-depot-promos]');
    if (!wrap) return;

    var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-depot-promo]'));
    if (slides.length < 2) return;
    if (wrap.getAttribute('data-rotate') !== 'true') return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) return;

    var seconds = parseInt(wrap.getAttribute('data-speed'), 10);
    if (isNaN(seconds) || seconds < 2) seconds = 5;

    var index = 0;
    var timer = null;

    function show(next) {
      slides[index].hidden = true;
      index = next % slides.length;
      slides[index].hidden = false;
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, seconds * 1000);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    // Pause while the tab is hidden so the rotation does not race ahead
    // and land on an unexpected message when the visitor returns.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    wrap.addEventListener('focusin', stop);
    wrap.addEventListener('focusout', start);

    start();
  }

  function init() {
    var roots = document.querySelectorAll('[data-depot-header]');
    Array.prototype.forEach.call(roots, function (root) {
      initMenu(root);
      initPromos(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place, so re-init on load.
  document.addEventListener('shopify:section:load', init);
})();
